<template>
	<div class="leason">
		<div class="leason_header">
			<div class="title">Book Trial</div>
			<img @click="close" src="../../assets/images/icon/close.png" alt="">
		</div>
		<div class="leason_box">
			
		
		<div class="leason_detail flex align-center">
			<div class="picture">
				<img :src="imgBaseUrl + orderDetail.course_details.image" alt="">
			</div>
			<div class="info">
				<div class="name">{{orderDetail.course_details.type.name}}</div>
				<!-- <div class="second">{{orderDetail.course_details.age.name}}</div> -->
				<div class="item">{{orderDetail.course_details.shop.name}}</div>
				<div class="item">{{orderDetail.course_details.age.name}}</div>
				<div class="item">{{orderDetail.course_details.start_date}}-{{orderDetail.course_details.end_date}}</div>
				<!-- <div class="item">{{orderDetail.course_details.start_time}}-{{orderDetail.course_details.end_time}}</div> -->
			</div>
		</div>
		<div class="price_box">
			<img class="intro_img" @click="toClassPack" src="../../assets/images/icon/click.png" alt="">
			<!-- <div class="first" @click="toClassPack">{{orderDetail.course_details.introduction}}<span >Click HERE for more info.</span> </div> -->
			<div class="second">Trial class:£{{tryPrice}}</div>
		</div>
		<div class="leason_list">
			
			<div class="item flex align-center justify-between" 
			:class="item.is_expired ? '' : 'main_item'"
			v-for="(item,index) in courseList" :key="index" @click="selectCourse(index)">
			<div v-if="item.is_expired">
				<img v-if="item.select" src="../../assets/images/icon/select_active.png" alt="">
				<img v-else src="../../assets/images/icon/select.png" alt="">
			</div>
				
				<div class="time" >
					<div>{{item.week}}</div>
					<div>{{item.start_date}}</div>
					<div>{{item.start_time}}-{{item.end_time}}</div>
				</div>
				<div class="name"> {{item.name}}</div>
			</div>
		</div>
		<div class="parent_info">
			<div class="discount_item flex align-center justify-between">
				<div class="name">Full Name:</div>
				<input type="text" class="val" v-model="full_name" placeholder="Full Name" >
			</div>
			<div class="discount_item flex align-center justify-between">
				<div class="name">Mobile:</div>
				<input type="text" class="val" v-model="contact_number" placeholder="Mobile" >
			</div>
			<div class="discount_item flex align-center justify-between">
				<div class="name">Email:</div>
				<input type="text" class="val" v-model="email" placeholder="Email" >
			</div>
		</div>
		<div class="discount_item flex align-center justify-between">
			<div class="name">Total Balance:</div>
			<div class="val">£{{tryPrice}}</div>
		</div>
		<!-- <div class="discount_item flex align-center justify-between">
			<div class="name">折扣码</div>
			<input type="text" class="val" v-model="discount_code" placeholder="优惠两节课" >
		</div> -->
		<div class="price_bottom flex align-center justify-between">
			<div class="price"></div>
			<div class="btn" @click="createOrder">Book Trial</div>
			
		</div>
		</div>
	</div>
</template>

<script>
	export default{
		props:{
			orderDetail:{
				type:Object
			},
			
			courseList:{
				type:Array
			},
			tryPrice:{
				type:String
			}
		},
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				totalMoney:0,
				full_name:'',
				email:'',
				contact_number:'',
				isBuy:false,
				course_product_id:''
			}
		},
		methods:{
			
			toClassPack(){
				this.$router.push('/home/classPack')
			},
			// 创建订单
			createOrder(){
				if(this.isBuy){
					return;
				}
				this.isBuy = true;
				this.course_product_id = ''
				this.courseList.forEach((item,index)=>{
					if(item.select){
						this.course_product_id = item.id
					}
				})
				if(!this.course_product_id){
					this.$message({
						showClose:true,
						duration:0,
						message:'please select course'
					})
					this.isBuy = false;
					return
				}
				
				var params = {
					full_name:this.full_name,
					contact_number:this.contact_number,
					email:this.email,
					course_product_id:this.course_product_id
				}
				this.$api.post('parents_order/submitOrderByTry',params,res=>{
					if(res.code == 1){
						this.isBuy = false;
						if(this.tryPrice > 0){
							this.pay(res.data.order_sn)
						}else{
							this.$message({
								showClose:true,
								duration:0,
								message:'Successful'
							})
							this.$router.push({path:'/home/userInfo/PaySuccess',query:{type:1}})
						}
						
						
					}else{
						this.isBuy = false;
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			pay(order_sn){
				this.$api.post('pay/stripe',{order_sn:order_sn,type:'pc'},res=>{
					if(res.code == 1){
						// this.$message('pay success');
						// this.$emit('close')
						// setTimeout(()=>{
						// 	this.$router.push('/home/userInfo/orderList')
						// })
						location.href=res.data.url
					}else{
						
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			
			
			close(){
				this.$emit('close')
			},
			
			selectCourse(index){
				if(!this.courseList[index].is_expired){
					return;
				}
				this.$emit('selectTryCourse',{index:index})
			},
			
		}
	}
</script>

<style lang="scss" scoped>
	.leason{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		width: 640px;
		height: 80%;
		background: #F7F2EB;
		box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
		border-radius: 10px;
		padding: 0 0 70px;
		overflow-y: scroll;
		.leason_header{
			width: 100%;
			height: 88px;
			border-bottom: 1px solid #5C707A;
			position: sticky;
			top:0;
			padding: 0 30px;
			background-color: #F7F2EB;
			.title{
				font-size: 30px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #282E30;
				line-height: 88px;
			}
			img{
				width: 29px;
				height: 28px;
				position: absolute;
				right: 30px;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		.leason_box{
			padding: 50px 40px;
		}
		.leason_detail{
			width: 100%;
			height: 200px;
			background: #F7F2EB;
			box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
			border-radius: 10px;
			margin-top: 30px;
			padding: 20px;
			.picture{
				width: 200px;
				height: 160px;
				overflow: hidden;
				margin-right: 20px;
				flex-shrink: 0;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.info{
				flex-grow: 1;
				.name{
					// width: 50%;
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 30px;
					height: 30px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.second{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 30px;
				}
				.item{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 30px;
				}
			}
		}
		.price_box{
			padding: 30px 0;
			border-bottom: 1px solid #5C707A;
			text-align: center;
			.first{
				font-size: 22px;
				font-family: Adobe Heiti Std;
				font-weight: normal;
				color: #C98B2C;
				margin-bottom: 30px;
				text-align: center;
				cursor: pointer;
			}
			.intro_img{
				width: 80%;
				height: auto;
				display: block;
				margin: 0 auto;
				cursor: pointer;
			}
			.second{
				font-size: 22px;
				font-family: Adobe Heiti Std;
				font-weight: normal;
				color: #BF5F49;
				text-align: center;
			}
		}
		.leason_list{
			border-bottom: 1px solid #5C707A;
			padding-bottom: 40px;
			.select_all{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #000000;
				padding-top: 20px;
				cursor: pointer;
				img{
					width: 27px;
					height: 28px;
					margin-right: 10px;
				}
			}
			.item{
				margin-top: 20px;
				width: 100%;
				height: 100px;
				background: #F7F2EB;
				box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
				border-radius: 10px;
				padding: 0 32px 0 20px;
				&.main_item{
					background: #EDE8E1;
					// display: none;
				}
				img{
					width: 27px;
					height: 28px;
				}
				.time{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 30px;
					text-align: center;
					div{
						text-align: center;
					}
				}
				.name{
					// width: 327px;
					height: 30px;
					font-size: 18px;
					font-family: DIN;
					font-weight: 400;
					color: #282E30;
					line-height: 30px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
		}
		.addChild{
			padding-top: 20px;
			padding-bottom: 40px;
			border-bottom: 1px solid #5C707A;
				.title{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #000000;
					margin-top: 16px;
					display: flex;
					align-items: center;
					cursor: pointer;
					img{
						width: 26px;
						height: 26px;
						margin-right: 10px;
					}
					.name{
						text-decoration: underline;
					}
				}
			.list{
				flex-wrap: wrap;
				.item{
					
					height: 60px;
					background: #F7F2EB;
					border: 1px solid #5C707A;
					border-radius: 10px;
					padding: 0 10px;
					margin-right: 20px;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 60px;
					img{
						margin-left: 20px;
						width: 26px;
						height: 26px;
					}
				}
				.add{
					// margin-left: 40px;
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					position: relative;
					cursor: pointer;
					img{
						width: 26px;
						height: 26px;
						margin-right: 10px;
					}
				}
				.childList{
					min-width: 200px;
					height: 200px;
					position: absolute;
					left: 0;
					top: 50px;
					border: 1px solid #ccc;
					border-radius: 10px;
					padding: 10px;
					background-color: #fff;
					overflow-y: scroll;
					.child_item{
						cursor: pointer;
						text-align: center;
						&.active{
							color: #C98B2C;
						}
					}
				}
			}
		}
		.discount_item{
			width: 100%;
			height: 62px;
			border-bottom: 1px solid #5C707A;
			padding: 0 30px 0 15px;
			.name{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
			}
			.val{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #BF5F49;
				text-align: right;
			}
		}
		.price_bottom{
			margin-top: 30px;
			.price{
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				span{
					color: #BF5F49;
				}
			}
			.btn{
				width: 182px;
				height: 58px;
				background: #5C707A;
				border-radius: 29px;
				line-height: 58px;
				text-align: center;
				font-size: 22px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #F7F2EB;
				margin-left: 10px;
				cursor: pointer;
			}
		}
	}
</style>